module.exports = __webpack_public_path__ + "x2.no1.76aaad88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/x2.no1.jpg
// module id = zfja
// module chunks = 0